import { MOCK_VISUAL_PROMPT_DEFINITIONS } from '@/mockData/visualPrompts/mockVisualPromptDefinitions';
import { getCustomVisualPrompts } from '@/utils/visualPrompts/customVisualPromptStorage';
import {
  applyFeaturedState,
  applyFeaturedStateToList,
} from '@/utils/visualPrompts/resolveVisualPromptFeatured';
import { sortPromptsByFeatured } from '@/utils/visualPrompts/sortPromptsByFeatured';
import type {
  VisualPromptListFilters,
  VisualPromptRepository,
} from './types';
import type { VisualPromptDefinition } from '@/types/visualPrompts/visualPrompt.types';

const filterDefinitions = (
  definitions: VisualPromptDefinition[],
  filters?: VisualPromptListFilters,
): VisualPromptDefinition[] => {
  let result = [...definitions];
  if (filters?.category && filters.category !== 'all') {
    result = result.filter((d) => d.category === filters.category);
  }
  if (filters?.search?.trim()) {
    const term = filters.search.trim().toLowerCase();
    result = result.filter(
      (d) =>
        d.title.toLowerCase().includes(term) ||
        d.description.toLowerCase().includes(term),
    );
  }
  return result;
};

export const combinedVisualPromptRepository: VisualPromptRepository = {
  async getAll(filters?: VisualPromptListFilters) {
    await Promise.resolve();
    const custom = getCustomVisualPrompts();
    const builtIn = MOCK_VISUAL_PROMPT_DEFINITIONS;
    return sortPromptsByFeatured(
      applyFeaturedStateToList(
        filterDefinitions([...custom, ...builtIn], filters),
      ),
    );
  },

  async getById(id: string) {
    await Promise.resolve();
    const custom = getCustomVisualPrompts().find((d) => d.id === id);
    const found =
      custom ?? MOCK_VISUAL_PROMPT_DEFINITIONS.find((d) => d.id === id) ?? null;
    return found ? applyFeaturedState(found) : null;
  },
};
